import { Controller } from "stimulus"
import SlimSelect from "slim-select";
import Rails from '@rails/ujs';

export default class extends Controller {
  connect() {
    const element = this.element;
    let options = { select: element };
    if (element.dataset.addable) {
      options = Object.assign(options, { addable: function (value) { return value } });
    }
    if (element.dataset.placeholder) {
      options = Object.assign(options, { placeholder: element.dataset.placeholder });
    }
    if (element.dataset.searchPlaceholder) {
      options = Object.assign(options, { searchPlaceholder: element.dataset.searchPlaceholder });
    }

    if (element.disabled) {
      options = Object.assign(options, { disabled: true });
    }
    if (element.dataset.searchText) {
      options = Object.assign(options, { searchText: element.dataset.searchText })
    }
    if (element.dataset.searchPlaceholder) {
      options = Object.assign(options, { searchPlaceholder: element.dataset.searchPlaceholder })
    }
    if (element.dataset.searchingText) {
      options = Object.assign(options, { searchingText: element.dataset.searchingText })
    }
    if (element.dataset.remote) {
      options = Object.assign(options, {
        ajax: function (search, callback) {

          if (search.length <= 1) {
            callback(false)
            return
          }

          const queryString = encodeURI(`search[name]=${encodeURIComponent(search)}`);
          let results = {}
          Rails.ajax({
            type: 'GET',
            url: element.dataset.url + '?' + queryString,
            dataType: 'json',
            success: (response) => {
              const values = response.map(option => ({ value: option[element.dataset.field] || option.id, text: option.name || option.title, url: option.url }))
              values.map(options => results[options.value] = options)
              callback(values)
              return values
            },
            error: (error) => {
              callback(false)
            }
          })
        }
      });

    }

    const slimSelect = new SlimSelect(options);
    // If the select has the required attribute we need to override
    // the default display value that slimselectjs applies
    // We also have to change the parentElement position
    // because we will apply a position: absolute to the select
    if (element.required) {
      element.parentElement.style.position = 'relative';
      element.style.display = 'block';
      element.style.position = 'absolute';
      element.style.clip = 'rect(0, 0, 0, 0)';
      element.style.pointerEvents = 'none';
    }
    // if we can add elements we want to be able to use the
    // enter key to add instead of clicking the icon
    // unfortunately we have to redo this check here
    // we can't do this on the block above since slimselect
    // wasn't initialized yet
    if (element.dataset.addable) {
      const searchField = slimSelect.slim.container.querySelector('input[type="search"]')
      const addIcon = slimSelect.slim.container.querySelector('.ss-addable')
      searchField.addEventListener('keydown', (event) => {
        // only add if there is nothing on the list to select
        if ((event.key == 'Enter' || event.keyCode == 13) && slimSelect.data.filtered.length == 0) {
          addIcon.click()
        }
      })
    }
  }
}
